"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatsigAsyncStorage = exports.EvaluationReason = exports.StatsigClient = exports.Layer = exports.DynamicConfig = void 0;
const Errors_1 = require("./Errors");
const StatsigClient_1 = __importDefault(require("./StatsigClient"));
const StatsigStore_1 = require("./StatsigStore");
const Object_entries_1 = __importDefault(require("./utils/Object.entries"));
const Object_fromEntries_1 = __importDefault(require("./utils/Object.fromEntries"));
const Promise_finally_1 = __importDefault(require("./utils/Promise.finally"));
var DynamicConfig_1 = require("./DynamicConfig");
Object.defineProperty(exports, "DynamicConfig", { enumerable: true, get: function () { return __importDefault(DynamicConfig_1).default; } });
var Layer_1 = require("./Layer");
Object.defineProperty(exports, "Layer", { enumerable: true, get: function () { return __importDefault(Layer_1).default; } });
var StatsigClient_2 = require("./StatsigClient");
Object.defineProperty(exports, "StatsigClient", { enumerable: true, get: function () { return __importDefault(StatsigClient_2).default; } });
var StatsigStore_2 = require("./StatsigStore");
Object.defineProperty(exports, "EvaluationReason", { enumerable: true, get: function () { return StatsigStore_2.EvaluationReason; } });
var StatsigAsyncStorage_1 = require("./utils/StatsigAsyncStorage");
Object.defineProperty(exports, "StatsigAsyncStorage", { enumerable: true, get: function () { return __importDefault(StatsigAsyncStorage_1).default; } });
(0, Object_entries_1.default)();
(0, Object_fromEntries_1.default)();
(0, Promise_finally_1.default)();
class Statsig {
    constructor() { }
    static async initialize(sdkKey, user, options) {
        var _a;
        const inst = (_a = Statsig.instance) !== null && _a !== void 0 ? _a : new StatsigClient_1.default(sdkKey, user, options);
        if (!Statsig.instance) {
            Statsig.instance = inst;
        }
        return inst.initializeAsync();
    }
    static async prefetchUsers(users) {
        return await Statsig.getClientX().prefetchUsers(users);
    }
    static setInitializeValues(initializeValues) {
        Statsig.getClientX().setInitializeValues(initializeValues);
    }
    static checkGate(gateName, ignoreOverrides = false) {
        return Statsig.getClientX().checkGate(gateName, ignoreOverrides);
    }
    static getConfig(configName, ignoreOverrides = false) {
        return Statsig.getClientX().getConfig(configName, ignoreOverrides);
    }
    static getExperiment(experimentName, keepDeviceValue = false, ignoreOverrides = false) {
        return Statsig.getClientX().getExperiment(experimentName, keepDeviceValue, ignoreOverrides);
    }
    static getLayer(layerName, keepDeviceValue = false) {
        return Statsig.getClientX().getLayer(layerName, keepDeviceValue);
    }
    static logEvent(eventName, value = null, metadata = null) {
        return Statsig.getClientX().logEvent(eventName, value, metadata);
    }
    static updateUser(user) {
        return Statsig.getClientX().updateUser(user);
    }
    static shutdown() {
        Statsig.getClientX().shutdown();
        Statsig.instance = null;
    }
    /**
     * Overrides the given gate locally with the given value
     * @param gateName - name of the gate to override
     * @param value - value to assign to the gate
     */
    static overrideGate(gateName, value) {
        Statsig.getClientX().overrideGate(gateName, value);
    }
    /**
     * Overrides the given config locally with the given value
     * @param configName - name of the config to override
     * @param value - value to assign to the config
     */
    static overrideConfig(configName, value) {
        Statsig.getClientX().overrideConfig(configName, value);
    }
    /**
     * @deprecated use removeGateOverride or removeConfigOverride
     * @param name the gate override to remove
     */
    static removeOverride(name) {
        Statsig.getClientX().removeOverride(name);
    }
    /**
     * @param name the gate override to remove
     */
    static removeGateOverride(name) {
        Statsig.getClientX().removeGateOverride(name);
    }
    /**
     * @param name the config override to remove
     */
    static removeConfigOverride(name) {
        Statsig.getClientX().removeConfigOverride(name);
    }
    /**
     * @deprecated use getAllOverrides
     * @returns the gate overrides
     */
    static getOverrides() {
        return Statsig.getClientX().getOverrides();
    }
    /**
     * @returns The local gate and config overrides
     */
    static getAllOverrides() {
        return Statsig.getClientX().getAllOverrides();
    }
    /**
     * @returns The Statsig stable ID used for device level experiments
     */
    static getStableID() {
        return Statsig.getClientX().getStableID();
    }
    /**
     *
     * @returns The reason and time associated with the evaluation for the current set
     * of gates and configs
     */
    static getEvaluationDetails() {
        var _a, _b;
        return ((_b = (_a = Statsig.instance) === null || _a === void 0 ? void 0 : _a.getEvaluationDetails()) !== null && _b !== void 0 ? _b : {
            reason: StatsigStore_1.EvaluationReason.Uninitialized,
            time: 0,
        });
    }
    static getClientX() {
        if (!Statsig.instance) {
            throw new Errors_1.StatsigUninitializedError();
        }
        return Statsig.instance;
    }
}
exports.default = Statsig;
Statsig.encodeIntializeCall = true;
Statsig.instance = null;
